module.exports = __webpack_public_path__ + "static/media/parallax-form-4.5e605220.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/common/parallax/parallax-form-4.svg
// module id = 1783
// module chunks = 146